const SEA_MOBILE_CODE_LIST = [
  '+1',
  '+39',
  '+91',
  '+55',
  '+60',
  '+61',
  '+62',
  '+63',
  '+64',
  '+65',
  '+66',
  '+673',
  '+84',
  '+855',
  '+856',
  '+81',
  '+95',
]

const LNA_MOBILE_CODE_LIST = [
  '+1',
  '+34',
  '+51',
  '+52',
  '+54',
  '+55',
  '+56',
  '+57',
  '+58',
  '+60',
  '+61',
  '+62',
  '+63',
  '+64',
  '+65',
  '+66',
  '+84',
  '+95',
  '+503',
  '+504',
  '+506',
  '+507',
  '+591',
  '+598',
  '+673',
  '+855',
  '+856',
]

export const HMTPhoneList = [
  { name: '台灣 +886', outer_id: 886 },
  { name: '香港 +852', outer_id: 852 },
  { name: '澳門 +853', outer_id: 853 },
  { name: '其他 +86', outer_id: 86 },
]

export const getMobileCodeList = () => {
  const plantform = import.meta.env.VITE_APP_PLATFORM;
  switch(plantform) {
    case 'hmt': 
    return HMTPhoneList;
    case 'lna':
    return LNA_MOBILE_CODE_LIST;
    case 'sea':
    return SEA_MOBILE_CODE_LIST;
  }
  return LNA_MOBILE_CODE_LIST;
}
